import React from 'react'
import PropTypes from 'prop-types'

import { Like, Back, Paper, Leaf, Bag } from './Svg'

// Новый компонент для половинок
class PolovinkiProduct extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      quantity: 1,
      leftPolovinka: null,
      rightPolovinka: null,
      price: 0
    }
  }

  componentDidMount() {
    this.calculateInitialPolovinki()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.product?.data?.id !== this.props.product?.data?.id) {
      this.calculateInitialPolovinki()
    }
  }

  calculateInitialPolovinki = () => {
    const { data } = this.props.product || {}
    const polovinki = data?.polovinki || []
    
    if (polovinki.length > 0) {
      const left = polovinki[0]
      const right = polovinki[polovinki.length - 1]
      const price = this.calculatePrice(left, right)
      
      this.setState({
        leftPolovinka: left,
        rightPolovinka: right,
        price: price,
        quantity: 1
      })
    }
  }

  calculatePrice = (left, right, quantity = this.state.quantity) => {
    const leftPrice = parseFloat(left?.price) || 0
    const rightPrice = parseFloat(right?.price) || 0
    return (leftPrice + rightPrice) * quantity
  }

  handleQuantityChange = (newQuantity) => {
    if (newQuantity < 1) return
    
    const { leftPolovinka, rightPolovinka } = this.state
    const price = this.calculatePrice(leftPolovinka, rightPolovinka, newQuantity)
    
    this.setState({
      quantity: newQuantity,
      price: price
    })
  }

  incrementQuantity = () => {
    this.handleQuantityChange(this.state.quantity + 1)
  }

  decrementQuantity = () => {
    this.handleQuantityChange(this.state.quantity - 1)
  }

  changePolovinka = (side, polovinka) => {
    const { leftPolovinka, rightPolovinka, quantity } = this.state
    
    if (side === 'left') {
      const price = this.calculatePrice(polovinka, rightPolovinka, quantity)
      this.setState({
        leftPolovinka: polovinka,
        price: price
      })
    } else {
      const price = this.calculatePrice(leftPolovinka, polovinka, quantity)
      this.setState({
        rightPolovinka: polovinka,
        price: price
      })
    }
  }

  handleAddToCart = () => {
    const { data } = this.props.product || {}
    const { quantity, leftPolovinka, rightPolovinka } = this.state
    const { id } = data || {}

    if (!id || !leftPolovinka || !rightPolovinka) {
      console.error('Missing required data for adding to cart')
      return
    }

    this.props.addToCart(leftPolovinka.id, quantity, ``, rightPolovinka.id)
  }

  renderPolovinkaImage = (polovinka, side) => {
    if (!polovinka?.image) return (
      <div className={`w-full h-full bg-gray-200 flex items-center justify-center ${
        side === 'left' ? 'clip-left' : 'clip-right'
      }`}>
        <span className="text-gray-500">Нет фото</span>
      </div>
    )

    return (
      <div className="relative w-full h-full overflow-hidden">
        <img 
          src={polovinka.image} 
          alt={polovinka.name}
          className={`w-full h-full object-cover ${
            side === 'left' ? 'clip-left' : 'clip-right'
          }`}
          style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%'
          }}
        />
      </div>
    )
  }

  render() {
    const { assets_path, product, favorite, changeFavorite, closeProductWin } = this.props
    const { data } = product || {}
    const { quantity, leftPolovinka, rightPolovinka, price } = this.state

    const polovinki = data?.polovinki || []

    return (
      <div className={`w-[100%] min-h-dvh overflow-x-hidden bg-white z-50 ${product?.show ? `` : `hidden`}`}>
        <div className='container min-h-dvh flex flex-col tracking-tight'>
          <div className='fixed top-[20px] left-0 w-full px-[10px] z-10'>
            <div className='container flex items-center justify-between'>
              <button
                onClick={() => closeProductWin()}
                className="w-[40px] h-[40px] rounded-full bg-white flex items-center justify-center flex-none text-black shadow-lg"
              >
                <Back />
              </button>
              <button
                onClick={() => changeFavorite(data?.id)}
                className={`w-[40px] h-[40px] rounded-full bg-white flex items-center justify-center flex-none shadow-lg ${
                  favorite.includes(data?.id) ? 'text-[#F66116]' : 'text-[#C9C9C9]' 
                }`}
              >
                <Like />
              </button>
            </div>
          </div>
          
          {product?.loading ?
            <div className="flex items-center justify-center h-[calc(100dvh-80px)]">
              <div className="w-10 h-10 border-4 border-[#5A91FF] border-t-transparent rounded-full animate-spin"></div>
            </div>
          :
            <>
              {/* Блок с изображениями половинок */}
              <div className='flex items-center justify-center flex-auto w-[calc(100%+20px)] ml-[-10px] z-0 relative'>
                <div className="flex w-full max-w-[435px] h-[290px] relative gap-[5px] px-[10px]">
                  {/* Левая половинка */}
                  <div className="flex-1 relative">
                    {this.renderPolovinkaImage(leftPolovinka, 'left')}
                  </div>
                  
                  {/* Правая половинка */}
                  <div className="flex-1 relative">
                    {this.renderPolovinkaImage(rightPolovinka, 'right')}
                  </div>
                </div>
              </div>

              {/* Селекторы выбора половинок */}
              <div className="flex gap-2 mx-[10px] mt-4">
                {/* Селектор левой половинки */}
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Левая часть</label>
                  <select 
                    value={leftPolovinka?.id || ''}
                    onChange={(e) => {
                      const selected = polovinki.find(p => p.id === e.target.value)
                      if (selected) this.changePolovinka('left', selected)
                    }}
                    className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    {polovinki.map(polovinka => (
                      <option key={polovinka.id} value={polovinka.id}>
                        {polovinka.name} ({polovinka.price}₽)
                      </option>
                    ))}
                  </select>
                </div>

                {/* Селектор правой половинки */}
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Правая часть</label>
                  <select 
                    value={rightPolovinka?.id || ''}
                    onChange={(e) => {
                      const selected = polovinki.find(p => p.id === e.target.value)
                      if (selected) this.changePolovinka('right', selected)
                    }}
                    className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    {polovinki.map(polovinka => (
                      <option key={polovinka.id} value={polovinka.id}>
                        {polovinka.name} - {polovinka.price}₽
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Карточка с информацией */}
              <div className="w-full mt-auto">
                <div
                  className="w-full mt-[10px] relative"
                  style={{
                    borderRadius: '0px',
                    borderTopLeftRadius: '25px',
                    borderTopRightRadius: '25px',
                    paddingTop: '22px',
                    paddingBottom: '15px',
                    backgroundColor: '#FFFFFF',
                    border: 'none',
                    marginLeft: '-10px',
                    width: 'calc(100% + 20px)',
                    boxShadow: '0px -2px 31.2px 0px #00000017'
                  }}
                >
                  {data?.metka?.name !== `` &&
                    <div className='absolute w-[100%] top-[-12px] left-0 flex justify-center'>
                      <div
                        style={{ backgroundColor: data?.metka?.color }}
                        className='h-[24px] rounded-full px-[10px] metka-shadow text-white text-[12px] flex items-center'
                      >
                        {data?.metka?.name}
                      </div>
                    </div>
                  }
                  <div className='w-[100%] text-center text-[#00000099] text-[14px]'>{data?.parent}</div>
                  <div className='w-[100%] text-center text-black text-[22px] px-[10px] leading-tight'>{data?.pagetitle}</div>
                  
                  {data?.introtext !== `` &&
                    <div className='leading-none p-[15px] relative rounded-[20px] items-center justify-between bg-[#F6F6F6] backdrop-blur-[30px] text-black text-center text-[14px] mt-[20px] mx-[15px]'>
                      <div>{data?.introtext}</div>
                      {data?.metka?.icon === `paper` &&
                        <div className='absolute top-[-12px] right-[calc(50%-15px)]'><Paper /></div>
                      }
                      {data?.metka?.icon === `leaf` &&
                        <div className='absolute top-[-12px] right-[calc(50%-15px)]'><Leaf /></div>
                      }
                    </div>
                  }

                  <div className='flex flex-col items-center justify-between gap-[10px] mx-[15px] mt-[14px]'>
                    <div className='flex w-[100%] rounded-[30px] bg-[#F6F6F6] h-[50px] items-center justify-between p-[5px]'>
                      <button 
                        onClick={this.decrementQuantity}
                        className="w-[40px] h-[40px] flex items-center justify-center"
                        disabled={quantity <= 1}
                      >
                        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path 
                            d="M1 1L11.5 1" 
                            stroke={quantity <= 1 ? "#C9C9C9" : "black"} 
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                      <div className='text-[16px] font-normal text-center'>
                        {quantity} шт
                      </div>
                      <button 
                        onClick={this.incrementQuantity}
                        className="w-[40px] h-[40px] flex items-center justify-center"
                      >
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.24512 1V11.5" stroke="black" strokeLinecap="round"/>
                          <path d="M1 6.25488L11.5 6.25488" stroke="black" strokeLinecap="round"/>
                        </svg>
                      </button>
                    </div>
                    <div 
                      className="flex flex-1 w-[100%] items-center gap-[9px] h-[50px] p-[5px] rounded-full cursor-pointer bg-[#5A91FF] bluebtn-shadow"
                      onClick={this.handleAddToCart}
                    >
                      <div className='flex flex-none items-center justify-center w-[40px] h-[40px] rounded-full bg-[#FFFFFF40]'>
                        <Bag />
                      </div>
                      <div className='text-[16px] flex flex-1 items-center justify-around gap-[5px] me-[12px] text-nowrap tracking-tight text-white'>
                        <div>Добавить в корзину</div>
                        <div> · </div>
                        <div>{price} ₽</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        </div>

        {/* CSS для обрезки изображений */}
        <style jsx>{`
          .clip-left {
            clip-path: none;
            object-position: left;
          }

          .clip-right {
            clip-path: none;
            object-position: right;
          }
        `}</style>
      </div>
    )
  }
}

PolovinkiProduct.propTypes = {
  assets_path: PropTypes.string,
  product: PropTypes.object,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  closeProductWin: PropTypes.func,
  addToCart: PropTypes.func
}

export default PolovinkiProduct